import { Injectable } from "@angular/core";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { UserPreference } from "../../models/UserPreference";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";
import { InventoryAccuracyParam } from "../../models/InventoryAccuracyParam";
import { DateRangeParam } from "../../models/DateRangeParam";
import { WidgethelperService } from "../widgethelper.service";

@Injectable()
export class InventoryaccuracyService {
  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { }

  chartOptions() {
    return {
      title: {
        text: "",
        textStyle: {
          color: "#fff"
        }
      },
      grid: {
        top: '10%'
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["Net CC Adjusted Count", "Net Inventory Accuracy %"],
        top: '5%',
        textStyle: {
          color: "#fff"
        }
      },
      xAxis: {
        type: "category",
        data: [],
        nameTextStyle: {
          color: "#fff"
        },
        axisLabel: {
          interval: 0,
          length: "100%",
          rotate: 30,
          color: "#fff"
        },
        splitArea: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        },
      },
      yAxis: [
        {
          name:'Count',
          splitLine: {
            show: false
          },
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        },
        {
          name:'Percentage',
          splitLine: {
            show: false
          },
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        }
      ],
      series: [
        {
          name: "Net CC Adjusted Count",
          type: "line",
          yAxisIndex:0,
          data: []
        },
        {
          name: "Net Inventory Accuracy %",
          type: "line",
          yAxisIndex:1,
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log("CurrentInventoryService");
    widget.dataLoaded = false;
    widget.Title = "Inventory Accuracy";
    let userPref: UserPreference = this._commonService.getUserPreference();
    let criteria: InventoryAccuracyParam = new InventoryAccuracyParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    (dateParam.RangeValue = this._widgetHelper.GetSummaryType(
      setting.PickType
    ));
    (dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(
      setting.PickType
    ));

    this._analyticsService.getDates(dateParam).subscribe(
      data => {
        if (
          data.Start_Date.toString() != "0001-01-01T00:00:00" &&
          data.End_Date.toString() != "0001-01-01T23:59:59.999"
        ) {
          criteria.StartDate = new Date(data.Start_Date);
          criteria.EndDate = new Date(data.End_Date);
          criteria.CustomerId = userPref.CustomerId;
          criteria.FacilityId = userPref.FacilityId;
          criteria.SummaryType = setting.MonitorType;
          console.time("getInventoryAccuracy");
          this._analyticsService.getInventoryAccuracy(criteria).subscribe(
            (result: any) => {
              console.timeEnd("getInventoryAccuracy");
              console.log("getInventoryAccuracy", result);
              let Report_Periods = [];
              let NET_CC_ADJUSTED_COUNT = [];
              let NET_INVENTORY_ACCURACY = [];

              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              if (result && result.length > 0) {
                for (let i = 0; i < result.length; i++) {
                  let rptdate = "";
                  if (criteria.SummaryType == "D") {
                    rptdate = this._commonService.formatDate(
                      result[i].CYCLE_DATE,
                      appSettings.chartDayFormat
                    );
                  }
                  if (criteria.SummaryType == "W") {
                    rptdate =
                      "Wk " +
                      this._commonService.formatDate(
                        result[i].WEEK_START_DATE,
                        appSettings.chartWeekFormat
                      );
                  }
                  if (criteria.SummaryType == "M") {
                    rptdate = result[i].MONTH_ABBR_NAME;
                  }
                  if (criteria.SummaryType == "Q") {
                    //rptdate = (kpiData[i].QUARTER_NAME);
                    rptdate =
                      result[i].YEAR_NUMBER +
                      " QTR" +
                      result[i].QUARTER_NUMBER;
                  }
                  if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                    Report_Periods.push(rptdate);
                  }

                  NET_CC_ADJUSTED_COUNT.push([rptdate, result[i].NET_CC_ADJUSTED_COUNT]);
                  NET_INVENTORY_ACCURACY.push([rptdate, result[i].NET_INVENTORY_ACCURACY]);
                }
              } else {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              widget.chartOptions.series[0].data = NET_CC_ADJUSTED_COUNT;
              widget.chartOptions.series[1].data = NET_INVENTORY_ACCURACY;
              widget.chartOptions.xAxis.data = Report_Periods;
              //console.log(result)  ;
              widget.dataLoaded = true;
              //this._commonService.lastUpdatedTime = result.LastUpdateTime;
            },
            err => {
              console.timeEnd("getInventoryAccuracy");
              console.log("getInventoryAccuracy", err);
              widget.dataLoaded = true;
              widget.errorMessage = errorMessages.apiError;
            }
          );
        }
      },
      err => {
        console.log("getDates", err);
        widget.dataLoaded = true;
        widget.errorMessage = errorMessages.apiError;
      }
    );
  }

  reload(widget: any) { }

  remove(widget: any) { }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/inventoryaccuracy.service.ts